export const recaptchaInit = async(page) => {

    const action = (page || 'home') + '_page';

    const token = await grecaptcha.execute('6LdJ_YonAAAAAHrnDWDYRHjm4MrQaHWjgNqmRQkY', {
         // const token = await grecaptcha.execute('6LcHvA8cAAAAAD28XU_57DgIgicHmHZ85gdEV3DE', {
            //RECAPTCHA_SITEKEY="6LdJ_YonAAAAAHrnDWDYRHjm4MrQaHWjgNqmRQkY"
        action: action

    })

    .then((token) => {

        if (token) {

            return token;
        }

        return false;

    });

    return token;
};
